module.exports = __webpack_public_path__ + "static/media/place-point.723d412d.gif";